<template>
    <div class="agency-slider" v-if="arrDashboard.length > 0">
        <div class="splide-agency" id="agency-slide">
            <div class="splide__track">
                <ul class="splide__list">
                    <li class="splide__slide"
                        v-for="(agency, k) in arrDashboard" :key="k"
                        @click="clickAgency(agency)">
                        <div>
                            <div class="agency-item" :style="getActiveStyle(agency)">
                                <div class="item">
                                    <img :src="agency.image_url"/>
                                </div>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
        </div>

        <!-- <div class="dashboard-pagination-prev">
            <button class="bg-yellow-400 p-2 mr-4" @click="btnPrev()">Prev</button>
        </div> -->
        <div class="dashboard-pagination-next">
            <img @click="btnNext()" src="../../../../assets/new/icon/ic-pagination-next.png"/>
        </div>
    </div>
</template>
<script>
import Splide from '@splidejs/splide'; //https://splidejs.com/
/**
 * @property {string} apiConfig (require) Dashboard config_list
 */
export default {
    name: "AgencySlider",
    props: {
        agency: Array,
    },
    data: function() {
        return {
            slider: null,
            arrDashboard: [],

            selectAgency: '',
            agencyNameActive: {
                border: "2px solid",
                color: "#f8a51b"
            },
            agencyNameInActive: {
                color : ""
            },
        };
    },
    created: function() {
        this.arrDashboard = this.agency;
        this.clickAgency(this.arrDashboard[0])
    },
    methods: {
        setSlider: function() {
            this.$nextTick(() => {
                this.slider = new Splide('#agency-slide', {
                    type : 'slide',
                    autoWidth: true,
                    pagination : false,
                    arrows: false,
                    gap: 15,
                }).mount()

                this.slider.on('move', (newIndex) => {
                    this.currentSliderIndex = newIndex
                })
            })
        },
        btnNext: function() {
            let next = this.currentSliderIndex + 1
            this.slider.go(next)
        },
        clickAgency: function (agency) {
            this.selectAgency = agency;
            this.$emit('changeAgency', agency);
            this.getActiveStyle()
        },
        getActiveStyle: function(agency) {
            if (this.selectAgency == agency) {
                return this.agencyNameActive;
            } else {
                return this.agencyNameInActive;
            }
        },
    },
}
</script>
<style lang="scss">
@import "@/style/base/base.scss";
</style>
<style lang="scss" scoped>
.agency-slider {
    position: relative;
    .agency-item {
        border-radius: 10px;
        margin-right: 16px;
        .item {
            display: flex;
            justify-content: center;
            width: 176px;
            img {
                width: auto;
                height: 80px;
                border-radius: 10px;
                margin: 0 auto;
            }
        }
    }

    .dashboard-pagination-next {
        position: absolute;
        top: 20%;
        right: -30px;
    }
}
</style>
